import { standardError } from '@/layers/core/deal/mappers/standardError';

export function ErrorMessage({
  title,
  data,
}: {
  title: string;
  data: unknown;
}) {
  return (
    <div className="flex w-full max-w-xl flex-col gap-4 rounded border-2 border-red-400 p-4">
      <p className="font-bold text-red-600">{title}:</p>
      <pre
        className="scroll-thin max-h-32 overflow-y-auto overflow-x-hidden whitespace-pre-wrap
          rounded bg-gray-100 p-2 text-gray-500"
      >
        {standardError(data)
          ?.replace(/^"/, '')
          ?.replace(/"$/, '')
          ?.replace(/\\n/g, `\n`)}
      </pre>
    </div>
  );
}
